'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nearbyVenuesKey = exports.loadVenues = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toArray2 = require('babel-runtime/helpers/toArray');

var _toArray3 = _interopRequireDefault(_toArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.filterValidVenues = filterValidVenues;
exports.getNearbyPopularVenues = getNearbyPopularVenues;
exports.doLoadVenues = doLoadVenues;
exports.watchSaga = watchSaga;

var _bound = require('redux/saga/entities/bound');

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _verify = require('helpers/verify');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getNearbyPopularVenues),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doLoadVenues),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchSaga);

var MAX_VENUES = 20;
var MIN_VENUES = 8;
var MIN_RATING = 4.0;
var RADIUS_ATTEMPTS = [5, 10, 30];

var LOAD_VENUE_DATA = 'cmsPage/modules/VisitableVenues/LOAD_VENUE_DATA';

var loadVenues = exports.loadVenues = function loadVenues(location) {
  return (0, _extends3.default)({ type: LOAD_VENUE_DATA }, location);
};

var nearbyVenuesKey = exports.nearbyVenuesKey = function nearbyVenuesKey(location) {
  return location && 'venues-near-' + location.lat + '-' + location.lon;
};

function filterValidVenues(venues) {
  try {
    return venues.filter(function (_ref) {
      var _ref$ratings = _ref.ratings,
          total = _ref$ratings.count.total,
          mean = _ref$ratings.mean;
      return mean >= MIN_RATING || total === 0;
    });
  } catch (error) {
    return [];
  }
}

function getNearbyPopularVenues(client, location, radii) {
  var key, _radii, _radii2, radius, nextRadii, _ref2, venues, validVenueCount;

  return _regenerator2.default.wrap(function getNearbyPopularVenues$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if ((0, _verify.isAbsent)(radii)) {
            radii = RADIUS_ATTEMPTS;
          }

          key = nearbyVenuesKey(location);
          _radii = radii, _radii2 = (0, _toArray3.default)(_radii), radius = _radii2[0], nextRadii = _radii2.slice(1);

          if (!(0, _verify.isAbsent)(radius)) {
            _context.next = 5;
            break;
          }

          return _context.abrupt('return');

        case 5:
          _context.next = 7;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.nearbyPopularVenues, [client, 0, {
            lat: location.lat,
            lon: location.lon,
            page_size: MAX_VENUES,
            page: 0,
            radius: radius
          }], { key: key });

        case 7:
          _ref2 = _context.sent;
          venues = _ref2.venues;
          validVenueCount = filterValidVenues(venues).length;

          if (!(validVenueCount < MIN_VENUES && !(0, _verify.isEmpty)(nextRadii))) {
            _context.next = 15;
            break;
          }

          _context.next = 13;
          return (0, _effects.put)(_bound.nearbyPopularVenues.resetAction({ key: key }));

        case 13:
          _context.next = 15;
          return (0, _effects.call)(getNearbyPopularVenues, client, location, nextRadii);

        case 15:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function doLoadVenues(client, _ref3) {
  var lat = _ref3.lat,
      lon = _ref3.lon;
  return _regenerator2.default.wrap(function doLoadVenues$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;

          if (![lat, lon].some(_verify.isAbsent)) {
            _context2.next = 3;
            break;
          }

          return _context2.abrupt('return');

        case 3:
          _context2.next = 5;
          return (0, _effects.call)(getNearbyPopularVenues, client, { lat: lat, lon: lon });

        case 5:
          _context2.next = 9;
          break;

        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2['catch'](0);

        case 9:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 7]]);
}

function watchSaga(client) {
  return _regenerator2.default.wrap(function watchSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, loadVenues().type, doLoadVenues, client);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}